
import { IconBrandMeta, IconRefresh, IconTrash, IconFileDescription } from '@tabler/icons-react'
import { Modal, Accordion, Badge } from 'react-bootstrap'
import { baseURL } from '../Utils/constants/constant'

export const FbFormModal = ({ show, setShow, facebookData }) => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            contentClassName="border-0 shadow-lg rounded-4"
            size="lg" // Increased size for better accordion readability
        >
            {/* Consistent Professional Header */}
            <Modal.Header closeButton className="border-bottom-0 pt-4 px-4 align-items-start">
                <div className="d-flex align-items-start gap-3">
                    <div
                        className="d-flex align-items-center justify-content-center rounded-3"
                        style={{
                            background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                            width: "42px",
                            height: "42px",
                            boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                        }}
                    >
                        <IconBrandMeta stroke={2} size={22} color={"white"} />
                    </div>
                    <div className="d-flex flex-column">
                        <Modal.Title className="h5 fw-bold m-0" style={{ color: '#1a202c', letterSpacing: '-0.01em' }}>
                            Facebook Lead Synchronization
                        </Modal.Title>
                        <small className="text-muted mt-1">
                            Manage your connected pages and synchronize forms to import leads directly.
                        </small>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">
                {facebookData?.length > 0 ? (
                    <Accordion flush className="custom-fb-accordion">
                        {facebookData.map((page, index) => (
                            <Accordion.Item eventKey={String(index)} key={page.page_id} className="border rounded-3 mb-3 overflow-hidden">
                                <Accordion.Header>
                                    <div className="d-flex align-items-center gap-2 w-100">
                                        <span className="fw-bold text-dark" style={{ fontSize: '0.95rem' }}>{page.page_name}</span>
                                        <Badge bg="light" className="text-muted border fw-medium rounded-pill ms-2" style={{ fontSize: '0.7rem' }}>
                                            {page.forms?.length || 0} Forms
                                        </Badge>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body className="bg-light-subtle p-0">
                                    <div className="list-group list-group-flush">
                                        {page.forms.map((form) => (
                                            <div key={form.form_id} className="list-group-item d-flex justify-content-between align-items-center px-4 py-3 border-light">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="p-2 bg-white rounded-2 border">
                                                        <IconFileDescription size={18} color="#64748b" />
                                                    </div>
                                                    <span className="fw-medium text-secondary" style={{ fontSize: '0.85rem' }}>
                                                        {form.form_name}
                                                    </span>
                                                </div>

                                                <div className="d-flex gap-2">
                                                    <button
                                                        className="btn-sync-action border-0 d-flex align-items-center gap-2"
                                                        title="Sync Leads"
                                                    >
                                                        <IconRefresh size={16} stroke={2.5} />
                                                        <span>Sync</span>
                                                    </button>
                                                    <button
                                                        className="btn-delete-action border-0 d-flex align-items-center justify-content-center"
                                                        title="Delete Connection"
                                                    >
                                                        <IconTrash size={16} />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                ) : (
                    <div className="text-center py-5 border rounded-3 bg-light mb-4">
                        <p className="text-muted m-0">No pages connected. Please login to Facebook.</p>
                    </div>
                )}

                {/* Footer Actions */}
                <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
                    <button
                        type="button"
                        onClick={() => setShow(false)}
                        className="btn-discard-fb px-4 py-2 fw-semibold"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={() => window.open(`${baseURL}/facebook`, "_self")}
                        className="btn-login-fb px-4 py-2 fw-bold d-flex align-items-center gap-2 shadow-sm"
                    >
                        <IconBrandMeta size={18} />
                        Reconnect Facebook
                    </button>
                </div>
            </Modal.Body>

            <style>{`
                .custom-fb-accordion .accordion-button:not(.collapsed) {
                    background-color: #f8fafc;
                    color: #7a3a5e;
                    box-shadow: none;
                }
                .custom-fb-accordion .accordion-button:focus {
                    box-shadow: none;
                    border-color: #e2e8f0;
                }
                
                /* Sync Button */
                .btn-sync-action {
                    background-color: #fdf2f8;
                    color: #7a3a5e;
                    padding: 6px 14px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 700;
                    transition: all 0.2s;
                }
                .btn-sync-action:hover {
                    background-color: #7a3a5e;
                    color: white;
                }

                /* Delete Button */
                .btn-delete-action {
                    background-color: #fff5f5;
                    color: #e03131;
                    width: 32px;
                    height: 32px;
                    border-radius: 6px;
                    transition: all 0.2s;
                }
                .btn-delete-action:hover {
                    background-color: #e03131;
                    color: white;
                }

                /* Bottom Buttons */
                .btn-discard-fb {
                    background: white;
                    color: #7a3a5e;
                    border: 1px solid #7a3a5e;
                    border-radius: 6px;
                    font-size: 14px;
                    transition: all 0.2s;
                }
                .btn-discard-fb:hover {
                    background: #7a3a5e;
                    color: white;
                }

                .btn-login-fb {
                    background: #7a3a5e;
                    color: white;
                    border: none;
                    border-radius: 6px;
                    font-size: 14px;
                    transition: all 0.2s;
                }
                .btn-login-fb:hover {
                    background: #4f243c;
                    transform: translateY(-1px);
                }
            `}</style>
        </Modal>
    )
}